import React from 'react';
import BlogPostCard from './BlogPostCard';
import BlogPagination from './BlogPagination';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';

const BlogPostsGrid = ({ 
  posts, 
  loading, 
  currentPage, 
  totalPages, 
  onPageChange 
}) => {
  // Safety check: ensure posts is always an array
  const safePosts = Array.isArray(posts) ? posts : [];

  if (loading) {
    return (
      <div className="blog-posts-grid">
        <div className="blog-posts-grid__loading">
          <FontAwesomeIcon icon={faSpinner} className="fa-spin" />
          <p>Loading posts...</p>
        </div>
      </div>
    );
  }

  if (safePosts.length === 0) {
    return (
      <div className="blog-posts-grid">
        <div className="blog-posts-grid__empty">
          <div className="blog-posts-grid__empty-icon">
            <FontAwesomeIcon icon={faSpinner} />
          </div>
          <h3>No posts found</h3>
          <p>Try adjusting your search or filter criteria.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="blog-posts-grid">
      <div className="blog-posts-grid__container">
        {safePosts.map((post) => (
          <BlogPostCard key={post.id} post={post} />
        ))}
      </div>
      
      {totalPages > 1 && (
        <BlogPagination 
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={onPageChange}
        />
      )}
    </div>
  );
};

export default BlogPostsGrid; 